import React from 'react';
import {AgGridReact} from 'ag-grid-react';
import "ag-grid-enterprise";
import styled from 'styled-components';
import DecimalRenderer from './col_render_numerodecimal';
import DecimalRenderer3 from './col_render_numerodecimal3';
import EnteroRenderer from './col_render_numeroentero';
import LinkEliminarRenderer from './col_render_link_elim';
import FechaRenderer from './col_render_fecha_corta';
import EnteroEditor from './col_edit_numeroentero';
import DecimalEditor from './col_edit_numerodecimal';
import CalculatorDecimalRenderer from './col_render_cal_numerodecimal';
import LinkModalRenderer from './col_render_link_modal';
import LinkAceptarRenderer from './col_render_link_aceptar';
import {LicenseManager} from "ag-grid-enterprise";
import './ag_grid.css';
import './theme_silver.css';
// Licencia de AgGridEnterprise
LicenseManager.setLicenseKey("DEPORPAS__ITERA._1Devs14_January_2020__MTU3ODk2MDAwMDAwMA==5aa6a1438a7277abd2515b0de1447d4a");

const ContenedorGrid = styled.div`
    width: 100%;
    height: ${props => props.altura};
    margin-bottom: 10px;
    margin-top: 10px;
`;

// Texto en español para los labels de aggrid.
const localeText = {
    // for filter panel
    page: 'Página',
    more: 'Más',
    to: 'a',
    of: 'de',
    next: 'Siguiente',
    last: 'Último',
    first: 'Primero',
    previous: 'Anterior',
    loadingOoo: 'Cargando...',
    // for set filter
    selectAll: 'Seleccionar todo',
    searchOoo: 'Buscar...',
    blanks: 'Vacías',
    // for number filter and text filter
    filterOoo: 'Filtrar...',
    applyFilter: 'Aplicar filtro...',
    // for number filter
    equals: 'Igual',
    notEqual: 'Diferente',
    lessThanOrEqual: 'Menor o igual que',
    greaterThanOrEqual: 'Mayor o igual que',
    inRange:'Dentro de un rango',
    lessThan: 'Menor que',
    greaterThan: 'Mayor que',
    // for text filter
    contains: 'Contiene',
    notContains: 'No contiene',
    startsWith: 'Inicia con',
    endsWith: 'Termina con',
    // the header of the default group column
    group: 'Grupo',
    // tool panel
    columns: 'Columnas',
    rowGroupColumns: 'Columnas pivote',
    rowGroupColumnsEmptyMessage: 'No ha especificado columnas para agrupar',
    valueColumns: 'Valores de columnas',
    pivotMode: 'Modo pivote',
    groups: 'Grupos',
    values: 'Valores',
    pivots: 'Pivotes',
    valueColumnsEmptyMessage: 'No se ha especificado columnas',
    pivotColumnsEmptyMessage: 'No se ha especificado columnas pivote',
    // other
    noRowsToShow: 'No se han cargado datos para mostrar',    
    // standard menu
    copy: 'Copiar',
    ctrlC: 'Ctrl+C',
    paste: 'Pegar',
    ctrlV: 'Ctrl+V'
}

export default class AgGridRender extends React.Component{       
    generarColumna(def_columna){
        let defcol={
            ...def_columna,
            headerName: def_columna.header,
            suppressMenu: (this.props.gridOptions.enableFilter?false:true) || !(def_columna.suppressFilter?false:true)            
        };

        switch(def_columna.type){                
            case "num_entero":
                defcol.cellRendererFramework = EnteroRenderer;
                break;
            case "num_decimal":
                defcol.cellRendererFramework = DecimalRenderer;
                break;
            case "num_decimal3":
                defcol.cellRendererFramework = DecimalRenderer3;
                break;
            case "link_elim":
                defcol.cellRendererFramework = LinkEliminarRenderer;
                break;                
            case "fecha":
                defcol.cellRendererFramework = FechaRenderer;
                break;
            case "num_entero_edit":
                defcol.cellEditorFramework = EnteroEditor;
                defcol.cellClass = 'number-cell';
                break;
            case "num_decimal_edit":
                defcol.cellEditorFramework = DecimalEditor;
                defcol.cellClass = 'number-cell';
                break;
            case "num_decimal_cal":
                defcol.cellRendererFramework = CalculatorDecimalRenderer;
                break;
            case "link_modal":
                defcol.cellRendererFramework = LinkModalRenderer;
                break;
            case "link_aceptar":
                defcol.cellRendererFramework = LinkAceptarRenderer;
                break;
            default:
                defcol.tooltipField = def_columna.field;
                break;
        }

        delete defcol.header;
        delete defcol.type;
        
        return defcol;
    }


    renderizarColumnas(def_columnas_input){        
        let def_columnas = [];
        def_columnas_input.forEach((columna)=>{            
            let defcol = {};
            if (columna.children){
                defcol.headerName = columna.header;
                defcol.headerClass = 'row-header-parent';
                let subcolumnas = [];
                columna.children.forEach((subcolumna)=>{
                    subcolumnas.push(this.generarColumna(subcolumna));
                });
                defcol.children = subcolumnas;
            }else{                        
                defcol = this.generarColumna(columna);
            }

            def_columnas.push(defcol);
        });
        return def_columnas;
    }
  
    render(){        
        return(
            
            <ContenedorGrid altura={this.props.altura}  className="ag-silver" >
                <AgGridReact                    
                    columnDefs={this.renderizarColumnas(this.props.columnas)}
                    rowData={this.props.data}
                    gridOptions={{...this.props.gridOptions, localeText}}
                    onGridReady={this.props.onGridReady}
                    suppressMovableColumns={true}
                    stopEditingWhenGridLosesFocus={true}
                    rowHeight={(this.props.alturaRow)?this.props.alturaRow:20}
                    headerHeight={20}
                    groupHeaderHeight={20}
                />                  
            </ContenedorGrid>
        );
    }
}